import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { IngresoEgreso } from "../../models/trust/empleado/IngresoEgreso";
import { IngresoEgresoService } from "../../service/trust/empleado/IngresoEgresoService";

export const DetalleIngresoEgreso = ({ toast, id, catalogos, permss, soloLectura, esIngreso }) => {

    const omodel = new IngresoEgreso();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [esOtroTipo, setEsOtroTipo] = useState(false);
    const menuRef = useRef(null);

    const ingresoEgresoSrv = new IngresoEgresoService();
    const tablaIngresoEgreso = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { inText, inDrop, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaIngresoEgreso.lazyParams, id]);

    const loadLazyData = () => {
        tablaIngresoEgreso.setLoading(true);
        const _params = { ...tablaIngresoEgreso.lazyParams, idp: id, esIngreso: esIngreso };
        ingresoEgresoSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaIngresoEgreso.setTotalRecords(res.data.total);
            tablaIngresoEgreso.setData(res.data.registros);
        }).finally(() => tablaIngresoEgreso.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setEsOtroTipo(false);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        if (esIngreso) data.otro = catalogos?.otro_ingreso;
        data.es_ingreso = esIngreso;

        const request = getValues('id') == null
            ? ingresoEgresoSrv.nuevo(data)
            : ingresoEgresoSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        ingresoEgresoSrv.consultar(idReg, { esIngreso: esIngreso }).then(res => {
            const _data = res.data.ingreso_egreso;
            setEsOtroTipo(_data.tipo?.cat_id === (esIngreso ? catalogos?.otro_ingreso?.cat_id : catalogos?.otro_egreso?.cat_id));
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const onChangeTipo = (e) => {
        setEsOtroTipo(e.value?.cat_id === (esIngreso ? catalogos?.otro_ingreso?.cat_id : catalogos?.otro_egreso?.cat_id));
        setValue('otro_detalle', '');
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este ingreso/egreso?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                ingresoEgresoSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_ingreso_egreso" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de {esIngreso ? "Ingresos" : "Egresos"}
            </span>
        </div>
    );

    return (
        <div className="componente-ingreso-egreso">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_ingreso_egreso" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaIngresoEgreso} datos={tablaIngresoEgreso.data} totalRegistros={tablaIngresoEgreso.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={`${getValues('id') == null ? 'Nuevo' : 'Editar'} ${esIngreso ? 'Ingreso' : 'Egreso'}`} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '580px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-arrow-right-arrow-left text-primary"></i>
                                    {esIngreso ? "INGRESO" : "EGRESO"}
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inDrop('tipo', esIngreso ? catalogos?.tipo_ingreso : catalogos?.tipo_egreso, { lab: omodel.optionLabel, chn: onChangeTipo }, esOtroTipo ? 6 : 12)}
                        {esOtroTipo && inText('otro_detalle', { icon: 'pi pi-pencil' }, 6)}

                        {inNumber('valor', 2, false, { prefix: '$ ' }, 12)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
